module.exports = __webpack_public_path__ + "static/media/thumbs-down.61834689.png";